(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('UtenteFirma', UtenteFirma);

    UtenteFirma.$inject = ['$resource', 'DateUtils'];

    function UtenteFirma ($resource, DateUtils) {
        var resourceUrl =  'api/utentes/firma/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
